import { Stack, Typography } from "@mui/material";

type Props = {
  message: string;
  isRead: boolean;
};

export const NotificationMessage = ({ message, isRead }: Props) => {
  return (
    <Stack>
      <Typography fontSize="16px" fontWeight={isRead ? 400 : 700}>
        {message}
      </Typography>
    </Stack>
  );
};
